import { useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import {
    FaTimes,
} from "react-icons/fa";
import { toast } from "react-toastify";

import { useUpdateManagerLocation } from "../../hooks/mutation";
import CustomSelect from "../common/select";

const ManagerAssignModal = ({
    isOpen,
    onClose,
    managersList,
    locationsList
}) => {
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
        },
    });

    const onSuccess = useCallback(() => {
        reset();
        toast.success("Success");
    }, [reset]);
    const onError = useCallback(() => {
        reset();
        toast.error("Failed");
    }, [reset]);

    const {
        mutate: updateManager,
        isPending: isUpdating
    } = useUpdateManagerLocation(onSuccess, onError);
    const handleSave = useCallback((_data) => {
        updateManager(_data);
    }, [updateManager]);

    return isOpen ? (
        <div className="modal-overlay">
            <div className="modal-container h-auto w-50">
                <div className="modal-header mb-0">
                    <button className="modal-close" onClick={onClose}>
                        <FaTimes size={20} />
                    </button>
                </div>
                <div className="w-full flex flex-col gap-2">
                    <p className="text-lg font-semibold mb-0">
                        Manage Location Assignment
                    </p>
                    <p className="modal-description">
                        Add a location to a manager (existing locations are kept)
                    </p>
                    <div className="form-field">
                        <Controller
                            control={control}
                            name="managerId"
                            rules={{
                                required: "Please select a manager"
                            }}
                            render={({ field: { value, onChange } }) => (
                                <div className="flex justify-between w-full items-center">
                                    <span>Select Manager</span>
                                    <CustomSelect
                                        size="small"
                                        value={value}
                                        onChange={onChange}
                                        id="manager-select"
                                        options={managersList}
                                    />
                                </div>
                            )}
                        />
                        {!!errors.managerId && (
                            <div className="flex w-full justify-end">
                                <span className="error-text">
                                    {errors.managerId.message}
                                </span>
                            </div>
                        )}
                    </div>

                    <div className="form-field">
                        <Controller
                            control={control}
                            name="locationId"
                            rules={{
                                required: "Please select a location"
                            }}
                            render={({ field: { value, onChange } }) => (
                                <div className="flex justify-between w-full items-center">
                                    <span>Select Location</span>
                                    <CustomSelect
                                        size="small"
                                        value={value}
                                        onChange={onChange}
                                        id="location-select"
                                        options={locationsList}
                                    />
                                </div>
                            )}
                        />
                        {!!errors.locationId && (
                            <div className="flex w-full justify-end">
                                <span className="error-text">
                                    {errors.locationId.message}
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="mt-4 flex justify-center">
                        <button
                            onClick={handleSubmit(handleSave)}
                            disabled={isUpdating}
                            className="justify-between p-2 pr-20 pl-20 rounded-lg mr-1 flex items-center custom-blue-button border-none"
                        >
                            Assign
                        </button>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
}

export default ManagerAssignModal;